import { CurrencyPipe, DatePipe, DecimalPipe } from "@angular/common";
import { Component } from "@angular/core";
//services

import { PaquetesAdquiridosService } from "src/app/core/services/paquetes-adquiridos.service";
import { PagosPaquetesService } from "src/app/core/services/pagos.paquetes.service";
@Component({
  selector: "app-mis-paquetes",
  standalone: true,
  imports: [CurrencyPipe, DatePipe, DecimalPipe],
  templateUrl: "./mis-paquetes.component.html",
  styleUrl: "../../../app.component.scss",
})
export class MisPaquetesComponent {
  currentUser: any;
  listadoPaquetes: any;
  userLocal: boolean = true;

  constructor(
    private __paquetesAdquiridosService: PaquetesAdquiridosService,
    private __pagosPaquetesService: PagosPaquetesService
  ) {}

  ngOnInit(): void {
    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.currentUser = JSON.parse(currentUser);
      this.userLocal = JSON.parse(currentUser).local;
    }
    this.getPaquetesByPaciente(this.currentUser.userId);
  }

  /**
   *
   * @param idPaciente
   */
  async getPaquetesByPaciente(idPaciente: string) {
    const paquetes: any =
      await this.__paquetesAdquiridosService.getDataByPaciente(idPaciente);

    try {
      const pagos: any =
        await this.__pagosPaquetesService.getDataByPaquetesAdquiridos(
          paquetes.map((paquete: any) => paquete.$id)
        );

      paquetes.forEach((paquete: any) => {
        const pago = pagos.find(
          (p: any) => p.referencia === "p_" + paquete.$id
        );
        paquete.pagoPaquete = pago || null;
        paquete.estadoPago = this.resolverEstadoPago(paquete, pago);
      });
    } catch (error) {
      console.error("Error consultando los pagos de los paquetes:", error);
      paquetes.forEach((paquete: any) => {
        paquete.estadoPago = this.resolverEstadoPago(paquete, null);
      });
    }

    this.listadoPaquetes = paquetes;
  }

  /**
   * Devuelve la etiqueta y el estilo del estado de pago del paquete.
   * El estado de pago puede venir como relación (objeto) o como texto.
   */
  resolverEstadoPago(paquete: any, pago: any) {
    const estado = (
      pago?.IdEstadoPago?.$id ??
      pago?.IdEstadoPago ??
      ""
    ).toString();

    switch (estado) {
      case "aprobada":
      case "aprobado":
      case "pagada":
        return { texto: "Pago aprobado", clase: "bg-success" };
      case "creada":
      case "pendiente":
        return { texto: "Pendiente de pago", clase: "bg-warning" };
      case "rechazada":
      case "rechazado":
        return { texto: "Pago rechazado", clase: "bg-danger" };
      default:
        // Sin registro de pago: se usa el campo activo del paquete
        return paquete?.activo
          ? { texto: "Pago aprobado", clase: "bg-success" }
          : { texto: "Pago pendiente", clase: "bg-warning" };
    }
  }

  /**
   *
   * @param date
   * @returns
   */
  convertToLocal(date: string | Date): Date {
    const utcDate = new Date(date);
    const localDate = new Date(utcDate.getTime() - -5 * 60 * 60 * 1000); // UTC-5
    return localDate;
  }
}
